import CustomInput from "@/components/CustomInput/CustomInput.vue";
import helper from "@/store/helpers/helper";

export default {
  name: "UrlBlock",
  components: {
    CustomInput
  },
  props: [
    "pasted",
    "placeholder",
    "id",
    "item",
    "min",
    "max",
    "isDisabled",
    "platform",
    "isUpdate"
  ],
  data() {
    return {
      link: ""
    };
  },
  methods: {
    inputPageLink(data) {
      this.link = data;
      const out = {
        id: parseInt(this.$props.id),
        data: this.link.inp,
        error: this.link.error
      };
      this.$emit("inpute", out);
    }
  },
  // created() {
  //   if (!this.pasted) {
  //     this.$emit("inpute", {
  //       id: parseInt(this.$props.id),
  //       data: `${helper.getLinkByName(this.$props.platform)}`,
  //       error: this.link.error
  //     });
  //   }
  //
  // }
};
